import {getScrollOffset} from '../pages/search-results/helper';
let scrollOffset;

exports.init = function () {
    const SPACEBAR_KEY_CODE = [0, 32];
    const ENTER_KEY_CODE = 13;
    const DOWN_ARROW_KEY_CODE = 40;
    const UP_ARROW_KEY_CODE = 38;
    const ESCAPE_KEY_CODE = 27;

    const dropdown = document.querySelector('.custom-dropdown');
    const dropdownListTopLeftBorder = document.querySelector('.custom-dropdown__border-left');
    const dropdownListTopRightBorder = document.querySelector('.custom-dropdown__border-right');
    const list = document.querySelector('.custom-dropdown__list');
    const listContainer = document.querySelector('.custom-dropdown__list-container');
    const listItems = document.querySelectorAll('.custom-dropdown__list-item');
    const dropdownSelectedNode = document.querySelector('#dropdown__selected');
    const listItemIds = [];

    dropdownSelectedNode.addEventListener('click', e => toggleListVisibility(e));
    dropdownSelectedNode.addEventListener('keydown', e => toggleListVisibility(e));

    let item;

    for (let i = 0; i < listItems.length; i++) {
        item = listItems[i];
        listItemIds.push(item.id);

        item.addEventListener('click', e => {
            scrollOffset = getScrollOffset();
            setSelectedListItem(e);
            closeList();
        });

        item.addEventListener('keydown', e => {
            switch (e.keyCode) {
                case ENTER_KEY_CODE:
                    scrollOffset = getScrollOffset();
                    setSelectedListItem(e);
                    closeList();
                    return;

                case DOWN_ARROW_KEY_CODE:
                    focusNextListItem(DOWN_ARROW_KEY_CODE);
                    return;

                case UP_ARROW_KEY_CODE:
                    focusNextListItem(UP_ARROW_KEY_CODE);
                    return;

                case ESCAPE_KEY_CODE:
                    closeList();
                    return;

                default:
                    return;
            }
        });
    }

    function setSelectedListItem(e) {
        let selectedTextToAppend = document.createTextNode(e.target.innerText);
        dropdownSelectedNode.innerHTML = '';
        dropdownSelectedNode.appendChild(selectedTextToAppend);
        dropdownSelectedNode.setAttribute('data-value', e.target.getAttribute('data-value'));
        dropdownSelectedNode.setAttribute('data-sort-id', e.target.getAttribute('data-sort-id'));

        var event = document.createEvent('Event');
        event.initEvent('plp.sortingupdated', true, false);
        event.detail = {
            scrollOffset: scrollOffset
        };
        window.dispatchEvent(event);
    }

    function closeList() {
        list.classList.remove('dropdown-open');
        dropdownSelectedNode.classList.remove('expanded');
        listContainer.setAttribute('aria-expanded', false);
    }

    function toggleListVisibility(e) {
        let openDropDown = SPACEBAR_KEY_CODE.includes(e.keyCode) || e.keyCode === ENTER_KEY_CODE;

        if (e.keyCode === ESCAPE_KEY_CODE) {
            closeList();
        }

        if (e.type === 'click' || openDropDown) {
            list.classList.toggle('dropdown-open');
            dropdownListTopRightBorder.style.width =
                list.offsetWidth - dropdownListTopLeftBorder.offsetWidth - dropdown.offsetWidth - 1 + 'px';
            dropdownSelectedNode.classList.toggle('expanded');
            listContainer.setAttribute('aria-expanded', list.classList.contains('dropdown-open'));
        }

        if (e.keyCode === DOWN_ARROW_KEY_CODE) {
            focusNextListItem(DOWN_ARROW_KEY_CODE);
        }

        if (e.keyCode === UP_ARROW_KEY_CODE) {
            focusNextListItem(UP_ARROW_KEY_CODE);
        }
    }

    function focusNextListItem(direction) {
        const activeElementId = document.activeElement.id;
        if (activeElementId === 'dropdown__selected') {
            document.querySelector(`#${listItemIds[0]}`).focus();
        } else {
            const currentActiveElementIndex = listItemIds.indexOf(activeElementId);
            if (direction === DOWN_ARROW_KEY_CODE) {
                const currentActiveElementIsNotLastItem = currentActiveElementIndex < listItemIds.length - 1;
                if (currentActiveElementIsNotLastItem) {
                    const nextListItemId = listItemIds[currentActiveElementIndex + 1];
                    document.querySelector(`#${nextListItemId}`).focus();
                }
            } else if (direction === UP_ARROW_KEY_CODE) {
                const currentActiveElementIsNotFirstItem = currentActiveElementIndex > 0;
                if (currentActiveElementIsNotFirstItem) {
                    const nextListItemId = listItemIds[currentActiveElementIndex - 1];
                    document.querySelector(`#${nextListItemId}`).focus();
                }
            }
        }
    }
};
